import { useDevPanelContext } from '../../DevPanel/context/DevPanelContext';
import { useLaunchpadContext } from '../contexts/LaunchpadContext';
import type { LaunchpadState } from '../Launchpad.types';

export const useLaunchpadState = (): LaunchpadState => {
  const {
    isLoading,
    hasError,
    activityItemsCount,
    actionTypes = [],
    resourceTypes = [],
  } = useLaunchpadContext();

  const { devToolUserActivityStates } = useDevPanelContext();
  const {
    isDevToolLoadingStateEnabled,
    isDevToolErrorStateEnabled,
    isDevToolEmptyStateEnabled,
    isDevToolDataStateEnabled,
    isDevToolZeroStateEnabled,
    isDevToolNoneStateEnabled,
  } = devToolUserActivityStates;

  if (Object.values(devToolUserActivityStates).some(Boolean) && !isDevToolNoneStateEnabled) {
    return {
      isLoadingState: isDevToolLoadingStateEnabled,
      isErrorState: isDevToolErrorStateEnabled,
      isEmptyState: isDevToolEmptyStateEnabled,
      isDataState: isDevToolDataStateEnabled,
      isZeroState: isDevToolZeroStateEnabled,
    };
  }

  const hasFiltersSelected = !!actionTypes.length || !!resourceTypes.length;
  const hasActivityFeed = activityItemsCount > 0;
  const hasNoActivityFeed = activityItemsCount === 0;

  return {
    isLoadingState: !!isLoading,
    isErrorState: !!hasError,
    isDataState: hasActivityFeed,
    isEmptyState: hasNoActivityFeed && !hasFiltersSelected,
    isZeroState: hasNoActivityFeed && hasFiltersSelected,
  };
};
